module.exports = __webpack_public_path__ + "img/guide4.ca3083bb.jpg";